<div class="chat-container">
  <div class="chat-container__channel-board--top" (scroll)="test()" (click)="showChatBox = false" *ngIf="!chatConfig.lockChat">
    <div class="chat-container__channel-board--top__title">
      {{ activeSubFeature != "Chatbot" ? channelListCategory : "Chat" }}
      @if (activeSubFeature === "Chatbot") {
        <div class="d-flex justify-content-center align-items-center ml-2">
          <span class="connection-status-text">
            {{ isConnected ? "" : "Connecting..." }}
          </span>
        </div>
      }
    </div>
    <div class="end-btns">
      <div class="refresh">
        <button (click)="refreshChat()" class="refresh-btn text-white"><i class="fa fa-refresh"></i></button>
      </div>

      <div ngbDropdown container="body" class="d-inline-block right" style="background-color: transparent; border: 0">
        <span ngbDropdownToggle id="dropdownMenuButton" class="bg-transparent text-white border-0">{{ chatMode }}</span>
        <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
          <button (click)="setMode('Main')" class="dropdown-item" aria-label="Main">Main</button>
          <button (click)="setMode('Archive')" class="dropdown-item" aria-label="Archive">Archive</button>
        </div>
      </div>
    </div>

    <!-- </span> -->
    <!-- <div ngbDropdown class="my-dropdown" #myDropdown="ngbDropdown">
      <button ngbDropdownToggle class="bg-transparent text-white border-0" type="button">
        {{ activeSubFeature == "Chatbot" ? channelListCategory : activeSubFeature }}
      </button>
      <div class="my-dropdown__menu p-0" ngbDropdownMenu style="width: 10px !important; top: 100px !important">
        <div class="my-dropdown__menu--item" (click)="setFeature('Chatbot', 'Main', myDropdown)" ngbDropdownItem>Main</div>
        <div class="my-dropdown__menu--item" (click)="setFeature('Chatbot', 'Archive', myDropdown)" ngbDropdownItem>Archive</div>
        <div class="my-dropdown__menu--item" (click)="setFeature('Learn', null, myDropdown)" ngbDropdownItem>Learn</div>
        <div class="my-dropdown__menu--item" (click)="setFeature('Memory', null, myDropdown)" ngbDropdownItem>Memory</div>
      </div> -->
    <!-- </div> -->
  </div>
  <ng-container *ngIf="activeSubFeature == 'Chatbot'">
    <app-chatbot [chatConfig]="chatConfig" (chatModeChange)="chatMode = $event" [chatMode]="chatMode" [currentlyTalkingToId]="currentlyTalkingTo" [forTypeId]="forTypeId" [forCategoryId]="forCategoryId" [isAdmin]="isAdmin"></app-chatbot>
  </ng-container>
  <ng-container *ngIf="activeSubFeature == 'Learn'" (scroll)="test()">
    <app-chatlearn></app-chatlearn>
  </ng-container>
  <ng-container *ngIf="activeSubFeature == 'Memory'">
    <app-chatmemory></app-chatmemory>
  </ng-container>
</div>
